import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  CircularProgress,
  Typography,
  Paper
} from "@material-ui/core";
import MemoryOutlinedIcon from "@material-ui/icons/MemoryOutlined";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const CONTEXT_OPTIONS = [5, 10, 20, 30, 50];

/**
 * Modal "IA de Vendas". Dispara POST /ai-assist/sales-suggestion,
 * recebe sugestao, exibe pra revisao e — ao Aplicar — injeta no
 * MessageInput via window event "ai-assist:set-input".
 *
 * Atendente sempre revisa/edita antes de enviar; modal nao envia
 * nada no WhatsApp.
 */
const SalesAiModal = ({ open, onClose, ticketId }) => {
  const [contextSize, setContextSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [suggestion, setSuggestion] = useState("");
  const [meta, setMeta] = useState(null);

  const handleClose = () => {
    setSuggestion("");
    setMeta(null);
    setContextSize(10);
    onClose();
  };

  const handleGenerate = async () => {
    setLoading(true);
    setSuggestion("");
    setMeta(null);
    try {
      const { data } = await api.post("/ai-assist/sales-suggestion", {
        ticketId,
        contextSize
      });
      setSuggestion(data.suggestion);
      setMeta({
        usedMessages: data.usedMessages,
        model: data.model,
        provider: data.provider
      });
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleApply = () => {
    if (!suggestion) return;
    // Dispatch evento global — MessageInput escuta e injeta no state
    window.dispatchEvent(
      new CustomEvent("ai-assist:set-input", {
        detail: { text: suggestion, ticketId }
      })
    );
    toast.success("Sugestao injetada no campo de mensagem.");
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <MemoryOutlinedIcon
          style={{ verticalAlign: "middle", marginRight: 8, color: "#6a1b9a" }}
        />
        IA de Vendas
      </DialogTitle>
      <DialogContent>
        <Typography variant="caption" color="textSecondary">
          Gera uma sugestao de resposta baseada nas ultimas mensagens da
          conversa. Voce revisa, edita e envia manualmente.
        </Typography>

        <TextField
          select
          label="Mensagens recentes a considerar"
          value={contextSize}
          onChange={e => setContextSize(Number(e.target.value))}
          fullWidth
          variant="outlined"
          size="small"
          style={{ marginTop: 16 }}
        >
          {CONTEXT_OPTIONS.map(n => (
            <MenuItem key={n} value={n}>
              {n} mensagens
            </MenuItem>
          ))}
        </TextField>

        {suggestion && (
          <Paper
            variant="outlined"
            style={{
              padding: 12,
              marginTop: 16,
              background: "#f9f5fc",
              borderColor: "#6a1b9a"
            }}
          >
            <Typography
              variant="caption"
              color="textSecondary"
              style={{ display: "block", marginBottom: 4 }}
            >
              Sugestao gerada
              {meta &&
                ` — ${meta.usedMessages} msgs, ${meta.provider}/${meta.model}`}
              :
            </Typography>
            <TextField
              value={suggestion}
              onChange={e => setSuggestion(e.target.value)}
              fullWidth
              variant="outlined"
              size="small"
              multiline
              minRows={4}
            />
            <Typography
              variant="caption"
              color="textSecondary"
              style={{ display: "block", marginTop: 8 }}
            >
              Pode editar acima antes de aplicar.
            </Typography>
          </Paper>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        {!suggestion ? (
          <Button
            variant="contained"
            color="primary"
            onClick={handleGenerate}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={16} /> : null}
          >
            {loading ? "Gerando..." : "Gerar sugestao"}
          </Button>
        ) : (
          <>
            <Button onClick={handleGenerate} disabled={loading}>
              Gerar de novo
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleApply}
            >
              Usar esta sugestao
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default SalesAiModal;
